import React, {Component} from 'react';
import PropTypes from 'prop-types';
import SidebarTree from './SidebarTree';
import SidebarItem from './SidebarItem';

class SidebarMultiTree extends Component {
	render() {
		const {title, url, iconClass, sideBarTree} = this.props;
		return (
			<li className="treeview">
				<a href={url}>
					<i className={iconClass}/> <span>{title}</span>
					<span className="pull-right-container">
						<i className="fa fa-angle-left pull-right"/>
					</span>
				</a>
				<ul className="treeview-menu">
					{
						sideBarTree.map((item, index) => {
							return (
								item.sideBarItem && item.sideBarItem.length
									? <SidebarTree title={item.title} sideBarItem={item.sideBarItem} key={index.toString()}/>
									: <SidebarItem title={item.title} url={item.url} key={index.toString()}/>
							)
						})
					}
				</ul>
			</li>
		)
	}
}

SidebarMultiTree.defaultProps = {
	url: '',
	iconClass: 'fa fa-circle-o'
};

SidebarMultiTree.propTypes = {
	title: PropTypes.string.isRequired,
	url: PropTypes.string,
	iconClass: PropTypes.string,
	sideBarTree: PropTypes.arrayOf(PropTypes.shape({
		title: PropTypes.string.isRequired,
		url:PropTypes.string,
		iconClass: PropTypes.string,
		sideBarItem: PropTypes.arrayOf(PropTypes.shape({
			title: PropTypes.string.isRequired,
			url: PropTypes.string.isRequired,
			iconClass: PropTypes.string
		}))
	})).isRequired
};

export default SidebarMultiTree